import HubspotContactForm from './ContactForm/HubspotContactForm';
import { INVESTOR_FORM_CONFIG } from './ContactForm/contactFormConfig';

export default function InvestInUsForm() {
  return <HubspotContactForm config={INVESTOR_FORM_CONFIG} />;
}
